import backImage from '@/assets/img/back_arrow.svg';
import bankBackImage from '@/assets/img/back_arrow_bank.svg';
import { getTrans } from '@/utils/tools';
import { ENQUIRY_DETAILS_STEP, TRACKING_TYPE, LIVE_AGENT_USER_TYPE, FAKE_SESSION_ID, TRACKING_SECTION } from '@/utils/constants';
import React, { Component } from 'react';
import { isBank } from '@/config/core';
import classnames from 'classnames';
import './style.scss';
import { tracker } from '@/utils/tracking';
import { inject, observer } from 'mobx-react';
import { getChildInject } from '@/utils/instantLoaded/tools';
import { InitStoreType } from '@/types/store/init';
import initStore from '@/stores/init';
import { handleRequest } from '@/utils';
import getUserTypeRetentionExperiment from '@/utils/experiment/getUserTypeRetention';
import { isAgentConnectionAutoFill } from '@/utils/experiment/getAgentConnectionAutoFillLogic';
import reportSkip, { LIVE_AGENT_UI_TYPE } from '@/utils/tracking/utils/liveAgentSkipTrack';

export type EnquiryItemType = {
  value: any;
  content: string;
  vipQueue?: string;
  isUserSelect?: boolean;
  isInboundOrder?: boolean;
  reasonCodeL1Id?: number;
  reasonCodeL1Name?: string;
  originItem?: any;

  child?: {
    value: any;
    content: string;
    isInboundOrder?: boolean;
    vipQueue?: string;
    isUserSelect?: boolean;
    reasonCodeL1Id?: number;
    reasonCodeL1Name?: string;
    originItem?: any;

    child?: {
      value: number;
      content: string;
      originItem?: any;
    }[];
  }[];
};

export type LiveAgentCacheVariable = {
  enquiry_type_map: {};
  chatbot_user_type: number;
  enquiry_type_id: number;
  order_id: string | number;
  order_info: {
    order_sn: string;
  }
}

interface Props {
  onClose?: Function;
  onChange?:({ userType, enquiryType }: {userType?: EnquiryItemType, enquiryType?: EnquiryItemType}) => void;
  dataSource: EnquiryItemType[];
  onSubmit?(data: EnquiryItemType[], initState?: State): void;
  initState?: State;
  liveAgentCacheVar?: LiveAgentCacheVariable;
}
export interface State {
  chooseCategory: {
    value: any;
    content: string;
    child: EnquiryItemType[];
    isUserSelect?: boolean;
    originItem?: any;
  };
  chooseOption: {
    value: any;
    content: string;
    isUserSelect?: boolean;
    isInboundOrder?: boolean;
  };
  step: number;
  useUserTypeRetentionExperiment: boolean;
}

const PREFIX = 'enquiry-details-modal-container';
export default class EnquiryList extends Component<Props, State> {
  static defaultProps = { dataSource: [] };

  constructor(props: Props) {
    super(props);

    this.state = props.initState || {
      chooseCategory: {
        value: undefined,
        content: '',
        child: [],
        isUserSelect: false,
      },
      chooseOption: {
        value: undefined,
        content: '',
        isUserSelect: false,
      },
      step: ENQUIRY_DETAILS_STEP.CHOOSE_CATEGORY,
      useUserTypeRetentionExperiment: getUserTypeRetentionExperiment(),
    };
  }

  componentDidMount() {
    // 判断如果只有一个用户类型时，默认选中，进行下一步
    const { props } = this;
    if (props.dataSource.length === 1) {
      const { value, content, child = [] } = props.dataSource[0];
      this.updateState({
        chooseCategory: { value, content, child },
        step: ENQUIRY_DETAILS_STEP.CHOOSE_OPTION,
      });

      this.props?.onChange?.({ userType: { value, content, child }});
    } else if (props?.liveAgentCacheVar && this.state.useUserTypeRetentionExperiment) { // 如果 是在实验组内 且有缓存数据时  user type 可以不用选择
      if (props?.liveAgentCacheVar?.chatbot_user_type !== LIVE_AGENT_USER_TYPE.NotChoose) {
        const userTypeData = props.dataSource.find((x) => x?.originItem?.user_type_label === LIVE_AGENT_USER_TYPE[props?.liveAgentCacheVar?.chatbot_user_type as LIVE_AGENT_USER_TYPE]);
        if (userTypeData) {
          const { value, content, child = [], originItem } = userTypeData;
          this.updateState({
            chooseCategory: { value, content, child, isUserSelect: true, originItem },
            step: ENQUIRY_DETAILS_STEP.CHOOSE_OPTION,
          });
          this.props?.onChange?.({ userType: { value, content, child }});
        }
      }
    }
    if (props?.liveAgentCacheVar && isAgentConnectionAutoFill()) {
      if (props?.liveAgentCacheVar?.chatbot_user_type !== LIVE_AGENT_USER_TYPE.NotChoose) {
        const userTypeData = props.dataSource.find((x) => x?.originItem?.user_type_label === LIVE_AGENT_USER_TYPE[props?.liveAgentCacheVar?.chatbot_user_type as LIVE_AGENT_USER_TYPE]);

        if (userTypeData) {
          const { value, content, child = [], originItem } = userTypeData;

          this.setState({
            chooseCategory: { value, content, child, isUserSelect: false, originItem },
            step: ENQUIRY_DETAILS_STEP.CHOOSE_OPTION,
          });

          reportSkip(LIVE_AGENT_UI_TYPE.BUTTON_SHEET, TRACKING_SECTION[TRACKING_TYPE.LIVE_AGENT_USER_TYPE_SELECTION], userTypeData?.content);

          const enquiry_type_map = props?.liveAgentCacheVar?.enquiry_type_map || {};
          if (Object.entries(enquiry_type_map).length !== 0) {
            setTimeout(() => {
              const options = userTypeData.child || [];
              const chatbotUserType = props?.liveAgentCacheVar?.chatbot_user_type;
              const selectedOption = options.find((x) => x.value === enquiry_type_map[chatbotUserType as keyof {}]);

              const { value, content = '', isInboundOrder = false } = selectedOption || {};

              this.setState({
                ...this.state,
                chooseOption: { value, content, isInboundOrder },
              }, () => {
                this.handleConfirm();
              });

              reportSkip(LIVE_AGENT_UI_TYPE.BUTTON_SHEET, TRACKING_SECTION[TRACKING_TYPE.LIVE_AGENT_ENQUIRY_TYPE_SELECTION], selectedOption?.content);

            }, 0);
          }

        }
      }
    }
  }

  updateState(name: string | Record<string, any>, value?: any) {
    if (typeof name === 'string') {
      this.setState({
        ...this.state,
        [name]: value,
      });
    } else {
      this.setState({
        ...this.state,
        ...name,
      });
    }
  }

  backStep = () => {
    this.updateState({
      step: ENQUIRY_DETAILS_STEP.CHOOSE_CATEGORY,
      chooseOption: undefined,
    });
  };

  closeModal = () => {
    this.props?.onClose?.();

    // 恢复state
    this.setState({
      chooseCategory: {
        value: undefined,
        content: '',
        child: [],
      },
      chooseOption: {
        value: undefined,
        content: '',
      },
      step: ENQUIRY_DETAILS_STEP.CHOOSE_CATEGORY,
    });
  };

  handleNext = () => {
    this.state.chooseCategory && this.updateState('step', ENQUIRY_DETAILS_STEP.CHOOSE_OPTION);
    const userType = this.state.chooseCategory;
    userType && this.props?.onChange?.({ userType });
    // update

    // 0 或 1 个咨询类型，直接提交
    const options = this.state.chooseCategory.child || [];
    if (options.length <= 1) {
      const { value, content = '', isInboundOrder = false } = options[0] || {};
      this.setState({
        ...this.state,
        chooseOption: { value, content, isInboundOrder },
      }, () => {
        this.handleConfirm();
      });
    }

    const notSessionId = !initStore.sessionId || initStore.sessionId === FAKE_SESSION_ID;
    // 在实验组里 且 user type 是 buyer 或者 seller 就存起来
    // 如果 session id 有问题就不需要存
    if (this.state.useUserTypeRetentionExperiment && (userType?.originItem?.user_type_label === LIVE_AGENT_USER_TYPE[1] || userType?.originItem?.user_type_label === LIVE_AGENT_USER_TYPE[2]) && !notSessionId) {
      handleRequest('liveAgentUpdateVariable', {
        session_id: initStore.sessionId,
        chatbot_user_type: LIVE_AGENT_USER_TYPE[userType?.originItem?.user_type_label],
      });
    }
  };

  handleConfirm = () => {
    if (!this.state.chooseOption) {
      return;
    }

    const enquiryType = this.state.chooseOption;
    this.props?.onChange?.({ enquiryType });
    this.props.onSubmit?.(
      [this.state.chooseCategory, this.state.chooseOption],
      { ...this.state, step: this.state.chooseCategory.child.length <= 1 ? ENQUIRY_DETAILS_STEP.CHOOSE_CATEGORY : this.state.step },
    );

    this.closeModal();
  };

  handleBtnClick = () => {
    if (this.state.step === ENQUIRY_DETAILS_STEP.CHOOSE_CATEGORY) {
      this.handleNext();
    } else {
      this.handleConfirm();
    }
  };

  render() {
    const { dataSource } = this.props;

    const { chooseCategory, step } = this.state;

    const modalData = {
      title: getTrans('enquiry_details_modal_category_title'),
      btn: getTrans('enquiry_details_modal_category_btn'),
      options: dataSource,
      currentTarget: 'chooseCategory' as 'chooseCategory' | 'chooseOption', // keyof State
    };
    if (step === ENQUIRY_DETAILS_STEP.CHOOSE_OPTION) {
      modalData.title = getTrans('enquiry_details_modal_option_title');
      modalData.btn = getTrans('enquiry_details_modal_option_btn');
      modalData.options = this.state.chooseCategory.child;
      modalData.currentTarget = 'chooseOption';
    }

    // 只有选中的 user type 有 0或1 个 enquiry type，按钮文本变为 done
    if (chooseCategory.value && chooseCategory.child.length <= 1) {
      modalData.btn = getTrans('enquiry_details_modal_option_btn');
    }

    const currentTargetValue = this.state[modalData.currentTarget];
    return (
      <div className={classnames(PREFIX, { 'chatbot-bank': isBank() })}>
        {step === ENQUIRY_DETAILS_STEP.CHOOSE_OPTION && dataSource.length > 1 ? (
          <div className="back-icon" onClick={this.backStep}>
            <img src={isBank() ? bankBackImage : backImage} />
          </div>
        ) : null}
        <div className="title">{modalData.title}</div>
        <div className="content-wrapper">
          {modalData.options.map((option, index: number) => {
            const checked
              = !!currentTargetValue
              && currentTargetValue.value === option.value
              && currentTargetValue.content === option.content;
            option.isUserSelect = true;
            return (
              <EnquiryItem
                // key 区分 usertype 和 enquirytype 不然可能不上报曝光
                key={`reason-${step === ENQUIRY_DETAILS_STEP.CHOOSE_CATEGORY ? 'userType' : 'enquiryType'}-${index}`}
                index={index}
                type={step === ENQUIRY_DETAILS_STEP.CHOOSE_CATEGORY ? 'userType' : 'enquiryType'}
                className={classnames('option-radio-wrapper', { 'option-radio-wrapper-checked': checked })}
                onClick={() => {
                  this.updateState(modalData.currentTarget, option);
                  setTimeout(() => {
                    this.handleBtnClick();
                  }, 0);
                }}
                content={option.content}
              />
            );
          })}
        </div>
      </div>
    );
  }
}

const EnquiryItem = tracker(inject(getChildInject('initStore'))(observer((props: {
  className?: string,
  onClick?: () => void,
  content: string,
  passedRef: any,
  tracker: any,
  index: number,
  initStore?: InitStoreType,
  type: 'userType' | 'enquiryType',
}) => {
  const trackingdata = {
    chat_session_id: props.initStore?.sessionId,
    button_name: props.content,
  };
  const trackingname = props.type === 'userType' ? TRACKING_TYPE.USER_TYPE_SELECTOR : TRACKING_TYPE.ENQUIRY_TYPE_SELECTOR;

  const onClick = () => {
    props.tracker.click?.({
      trackingname,
      data: trackingdata,
    });
    props.onClick?.();
  };

  return (
    <div
      className={props.className}
      onClick={onClick}
      ref={props.passedRef}
      data-trackingname={trackingname}
      data-trackingindex={`${trackingname}-${props.index}`}
      data-trackingdata={JSON.stringify(trackingdata)}
    >
      <span className="content">
        {props.content}
      </span>
    </div>
  );
})));
